(function (Drupal) {
  Drupal.behaviors.cvEspecialista = {
    attach: function (context, settings) {
      // Selecciona el primer botón de tab
      var firstTabEl = document.querySelector("#actividadCientificaTab li:first-child button");
      if (firstTabEl) {
        // Si existe el primer tab, lo activamos usando el método Bootstrap.Tab
        firstTabEl.classList.add("active");
        var tabContent = document.querySelector("#actividadCientificaTabContent .tab-pane:first-child");
        if (tabContent) {
          tabContent.classList.add("show", "active");
        }
      }

      // Función para altura de las cards en el slider "Especialistas que te puedan interesar"
      // Verifica si existe la clase flickity-doctores
      if (document.querySelector(".flickity-doctores")) {
        const flickityViewport = document.querySelectorAll(".flickity-viewport");
        const viewsFields = document.querySelectorAll(".views-field");

        if (viewsFields.length > 0) {
          // Inicializa la variable para almacenar la altura máxima
          let maxHeight = 0;

          // Encuentra la altura más alta
          viewsFields.forEach(function (field) {
            const fieldHeight = field.offsetHeight;
            if (fieldHeight > maxHeight) {
              maxHeight = fieldHeight;
            }
          });

          // Asígna la altura a la clase que contiene el slide
          flickityViewport.forEach(function (container) {
            container.style.height = maxHeight + 10 + "px";
          });

          // Asigna la altura máxima a todos los divs con la clase views-field
          viewsFields.forEach(function (field) {
            field.style.height = maxHeight + "px";
          });
        }
      }
    },
  };
})(Drupal);
